import { figBorderColors, figSurfaceColors, figTextColors } from './fig/fig-colors';
import { Palette as C } from './vars';

export const textColor = {
  ...figTextColors,
  todo: 'rebeccapurple',
  tooltip: {
    DEFAULT: figSurfaceColors.tooltip.DEFAULT,
    S: figSurfaceColors.tooltip.S,
  },
};

export const borderColor = {
  ...figBorderColors,
};

export const surfaceColors = {
  ...figSurfaceColors,
  todo: 'rebeccapurple',
  transparent: 'transparent',
  w: C.White,
  white: C.White,
  b: C.Black,
  black: C.Black,
  'border-gradient': {
    start: C.Grey.$100,
    end: { DEFAULT: C.Cornflower.$200, H: C.Cornflower.$400 },
  },
};
